import { Injectable, signal, WritableSignal } from '@angular/core';
import { UserInfo } from '../models/user-info.model';

@Injectable({ providedIn: 'root' })
export class UserStateService {
  employeeName: WritableSignal<string> = signal('');
  companyId: WritableSignal<string> = signal(localStorage.getItem('companyId') || '');
  userId: WritableSignal<string> = signal('');
  givenName: WritableSignal<string> = signal('');
  surname: WritableSignal<string> = signal('');
  email: WritableSignal<string> = signal('');

  setEmployeeName(name: string) {
    this.employeeName.set(name);
  }

  setCompanyId(id: string) {
    this.companyId.set(id);
    localStorage.setItem('companyId', id);
  }

  setUserFromUserInfo(user: UserInfo): void {
    this.userId.set((user.sub || '').toUpperCase());
    this.givenName.set(user.given_name || '');
    this.surname.set(user.family_name || '');
    this.email.set(user.email || '');
    this.setEmployeeName(
      `${user.given_name || ''} ${user.family_name || ''}`.trim()
    );
    this.setCompanyId(user.departmentnumber || '');
  }

  clearUserIdentity(): void {
    this.userId.set('');
    this.givenName.set('');
    this.surname.set('');
    this.email.set('');
    this.employeeName.set('');
  }
}
